import { CONFIG } from "../../config/app.config";
import api from "../../utils/api/api.utils";
export var getRequirements = function () {
    return api.get("https://frontend-feature-flags.s3-eu-west-1.amazonaws.com/requirements_".concat(CONFIG.ENVIRONMENT.toLowerCase(), ".json"), { isFullUrl: true, isRentioUrl: false });
};
